export class BatchFetchResponse {
  batchId: BatchDetailModel;
  cohortId: string;
  priority: number;

  constructor(data: any = {}) {
    this.batchId =
      new BatchDetailModel(data?.batchId) || new BatchDetailModel({});
    this.cohortId = data?.cohortId || "";
    this.priority = data?.priority || "";
  }
}

export class BatchDetailModel {
  _id: string;
  multilingualStrip: MultilingualStripModal;
  isVernacular: boolean;
  type: string;
  name: string;
  byName: string;
  description: string;
  batchCode: string;
  startDate: Date;
  endDate: Date;
  priceLabel: string;
  fee: Fee;
  isAskSaarthiEnabled: boolean;
  isPurchased: boolean;
  isBlocked: boolean;
  isChatBlocked: boolean;
  subjects: Subject[];
  isAvailableFromPoints: boolean;
  isSelfLearning: boolean;
  maxWalletPoint: number;
  registrationStartDate: Date;
  registrationEndDate: Date;
  previewImage: FileModal;
  batchPdf: BatchPdf;
  previewVideoType: string;
  previewVideoUrl?: any;
  previewVideoId?: any;
  faqCat: string;
  attachTestCat: boolean;
  testCat: string;
  testCats: string[];
  meta: Meta[];
  orientationClassBanner: ImageId;
  previewVideoDetails: any;
  enableStudyMaterial: boolean;
  enableCommunity: boolean;
  enableMentorship: boolean;
  studyMaterials: StudyMaterial[];
  markedAsNew: boolean;
  isClassLive: boolean;
  isPathshala: boolean;
  program: Program;
  programId: string;
  slug: string;
  exam: string[];
  khazanaProgramId: string;
  class: string;
  board: string;
  language: string;
  isActive: boolean;
  isNeet: string;
  teachers: Teacher[];
  config: BatchDetailConfig;
  dRoomId: string;
  packValidity: number;
  shortDescription: string;
  batchExpiry: Date;
  metaText: string;
  notifyMeStatus: string;
  enableCommunityWeb: boolean;
  discountExpiryDate?: any;
  discountLabel?: any;
  discountValue?: any;
  plan: string;
  isSatExamEnable: boolean;
  cohortId: string;
  isInfinitePracticeEnabled: boolean;
  infinitePracticeVideoType: string;
  infinitePracticeVideoUrl: string;
  fomoIcons: string[];
  isBatchPlusEnabled: boolean;
  testPress: TestPress;
  ctaText: string;
  masterBatchId?: string;
  webinarId: string;
  tagImage: string;
  batchPdfUrl: string;
  template: string;
  isBatchClubbing: boolean;
  isPlanEnabled: boolean;
  isSahayakInfinitePracticeEnabled: boolean;
  isVPClubbingEnabled: boolean;
  formId: string;
  amountTitle: string | undefined;
  expiryDate: Date;
  isExpiringSoon?: boolean;
  expiryDays?: number;
  isFree?: boolean;
  isEZPayEnabled: boolean;
  isMultilingual: boolean;
  isHinglish: boolean;
  relatedMultiLingualBatchId: string;

  constructor(data: any) {
    data = data || {};
    this._id = data._id || "";
    this.type = data.type || "";
    this.name = data.name || "";
    this.byName = data.byName || "";
    this.description = data.description || "";
    this.batchCode = data.batchCode || "";
    this.program = new Program(data.programId) || new Program({});
    this.programId = data?.programId || "";
    this.previewVideoType = data.previewVideoType || "";
    this.faqCat = data.faqCat || "";
    this.language = data.language || "";
    this.testCat = data.testCat || "";
    this.tagImage = data.tagImage || "";
    this.maxWalletPoint = data.maxWalletPoint || 0;
    this.isAskSaarthiEnabled = data.isAskSaarthiEnabled || false;
    this.isPurchased = data.isPurchased || false;
    this.isBlocked = data.isBlocked || false;
    this.isAvailableFromPoints = data.isAvailableFromPoints || false;
    this.attachTestCat = data.attachTestCat || false;
    this.enableStudyMaterial = data.enableStudyMaterial || false;
    this.enableCommunity = data.enableCommunity || false;
    this.enableMentorship = data.enableMentorship || false;
    this.markedAsNew = data.markedAsNew || false;
    this.isClassLive = data.isClassLive || false;
    this.isPathshala = data.isPathshala || false;
    this.isSelfLearning = data.isSelfLearning || false;
    this.startDate = data.startDate || "";
    this.endDate = data.endDate || "";
    this.registrationStartDate = data.registrationStartDate || "";
    this.registrationEndDate = data.registrationEndDate || "";
    this.fee = new Fee(data.feeId || data.fee || {});
    this.previewImage = new FileModal(data.previewImage || {});
    this.orientationClassBanner =
      new ImageId(data.orientationClassBanner) || new ImageId({});
    this.batchPdf = data.batchPdf || {};
    this.subjects = data.subjects || [];
    this.testCats = data.testCats || [];
    this.meta = data.meta || [];
    this.studyMaterials = data.studyMaterials || [];
    this.slug = data.slug || "";
    this.exam = data.exam || [];
    this.previewVideoDetails = data.previewVideoDetails || {};
    this.isChatBlocked = data.isChatBlocked || false;
    this.khazanaProgramId = data.khazanaProgramId || "";
    this.class = data.class || "";
    this.board = data.board || "";
    this.language = data.language || "";
    this.isNeet = data.isNeet || "";
    this.isActive = data.isActive || false;
    this.teachers = data.teachers || [];
    this.config =
      new BatchDetailConfig(data.config) || new BatchDetailConfig({});
    this.dRoomId = data.dRoomId || "";
    this.previewVideoUrl = data.previewVideoUrl || "";
    this.packValidity = data.packValidity || 0;
    this.shortDescription = data.shortDescription || "";
    this.batchExpiry = data.batchExpiry || "";
    this.metaText = data.metaText || "";
    this.notifyMeStatus = data.notifyMeStatus || "";
    this.enableCommunityWeb = data.enableCommunityWeb || false;
    this.discountExpiryDate = data.discountExpiryDate || "";
    this.discountLabel = data.discountLabel || "";
    this.discountValue = data.discountValue || 0;
    this.plan = data.plan || "";
    this.isSatExamEnable = data.isSatExamEnable || false;
    this.cohortId = data.cohortId || "";
    this.isInfinitePracticeEnabled = data.isInfinitePracticeEnabled || false;
    this.infinitePracticeVideoType = data.infinitePracticeVideoType || "";
    this.infinitePracticeVideoUrl = data.infinitePracticeVideoUrl || "";
    this.isBatchPlusEnabled = data.isBatchPlusEnabled || false;
    this.fomoIcons = data.fomoIcons || [];
    this.testPress = data.testPress || new TestPress({});
    this.masterBatchId = data.masterBatchId || "";
    this.webinarId = data.webinarId || "";
    this.batchPdfUrl = data.batchPdfUrl || "";
    this.template = data.template || "";
    this.isBatchClubbing = data.isBatchClubbing || false;
    this.priceLabel = data.priceLabel || "";
    this.isPlanEnabled = data.isPlanEnabled || false;
    this.ctaText = data.ctaText || "";
    this.isSahayakInfinitePracticeEnabled =
      data.isSahayakInfinitePracticeEnabled || false;
    this.isVPClubbingEnabled = data.isVPClubbingEnabled || false;
    this.formId = data.formId || "";
    this.amountTitle = data?.amountTitle;
    this.isExpiringSoon = data.isExpiringSoon || false;
    this.expiryDays = data.expiryDays || 0;
    this.isFree = data.isFree || false;
    this.expiryDate = data.expiryDate || "";
    this.isEZPayEnabled = data?.isEZPayEnabled || false;
    this.isVernacular = data.isVernacular || false;
    this.multilingualStrip = new MultilingualStripModal(
      data.multilingualStrip || {},
    );
    this.isHinglish = data.isHinglish || false;
    this.isMultilingual = data.isMultilingual || false;
    this.relatedMultiLingualBatchId = data.relatedMultiLingualBatchId || "";
  }
}

export class MultilingualStripModal {
  languages: Languages[];
  constructor(data: any = {}) {
    if (data?.languages?.length) {
      this.languages = data.languages.map((lang: any) => new Languages(lang));
    } else {
      this.languages = [];
    }
  }
}

export class Languages {
  language: string;
  languageDetails: LanguageDetails;

  constructor(data: any = {}) {
    this.language = data.language || "";
    this.languageDetails = new LanguageDetails(data.languageDetails || {});
  }
}

export class LanguageDetails {
  name: string;
  code: string;
  symbol: string;
  constructor(data: any = {}) {
    this.name = data.name || "";
    this.code = data.code || "";
    this.symbol = data.symbol || "";
  }
}

class TestPress {
  freeBatchId: string;
  paidBatchId: string;
  subTitle: string;
  title: string;

  constructor(data: any) {
    data = data || {};
    this.freeBatchId = data?.freeBatchId || "";
    this.paidBatchId = data?.paidBatchId || "";
    this.subTitle = data?.subTitle || "";
    this.title = data?.title || "";
  }
}
export class FileModal {
  _id: string;
  baseUrl: string;
  key: string;
  name: string;
  url: string;
  status: string;
  iconUrl: string;

  constructor(file: any) {
    file = file || {};
    this._id = file._id || "";
    if (file.base_url) {
      this.baseUrl = file.base_url || "";
    } else if (file.baseUrl) {
      this.baseUrl = file.baseUrl;
    } else {
      this.baseUrl = "";
    }

    this.key = file.key || "";
    this.name = file.name || "";
    this.url = this.baseUrl + this.key || "";
    this.status = "";
    this.iconUrl = "";
  }
}

export class BatchDetailConfig {
  enableBatchReferAndEarn: boolean;
  isVidyapeeth: boolean;
  isFormEnabled: boolean;
  isSubjective: boolean;
  isStartDateEnabled: boolean;
  isEndDateEnabled: boolean;
  isTeacherNameEnabled: boolean;
  referAndEarnExpireAt: string;
  defaultFbt: string;
  defaultAddon: string;
  fbtTitle: string;
  isAddonVisible: boolean;
  addonsTitle: string;
  addonsDescription: string;
  fbtPageTitle: string;
  isPremium: boolean;
  is_combo_mandatory: boolean;
  enableDpp: boolean;
  enableDppPdfs: boolean;
  enableDppVideos: boolean;
  enableNotes: boolean;
  tagImage: string;
  offlineOfferingbatchTag: string;
  isFormFilled: boolean;
  batchActivationFormLink: string;
  isAccessRevoked: boolean;
  contactSupport: boolean;
  emiCreation: EmiCreationEnum;
  paymentType: string;
  isEZPayEnabled: boolean; 
  centerTypeIds?: string[];
  verticalId?: string;

  constructor(data: any) {
    data = data || {};
    this.enableBatchReferAndEarn = data.enableBatchReferAnd || false;
    this.isVidyapeeth = data.isVidyapeeth || false;
    this.isFormEnabled = data.isFormEnabled || false;
    this.isSubjective = data.isSubjective || false;
    this.isStartDateEnabled = data.isStartDateEnabled || false;
    this.isEndDateEnabled = data.isEndDateEnabled || false;
    this.isTeacherNameEnabled = data.isTeacherNameEnabled || false;
    this.isAddonVisible = data.isAddonVisible || false;
    this.referAndEarnExpireAt = data.referAndEarnExpireAt || "";
    this.defaultFbt = data.defaultFbt || "";
    this.defaultAddon = data.defaultAddon || "";
    this.fbtTitle = data.fbtTitle || "";
    this.addonsTitle = data.addonsTitle || "";
    this.addonsDescription = data.addonsDescription || "";
    this.fbtPageTitle = data.fbtPageTitle || "";
    this.isPremium = data.isPremium || false;
    this.is_combo_mandatory = data.is_combo_mandatory || false;
    this.tagImage = data.tagImage || "";
    this.offlineOfferingbatchTag = data.offlineOfferingbatchTag || "";
    this.isFormFilled = data?.isFormFilled || false;
    this.batchActivationFormLink = data?.batchActivationFormLink || "";
    this.isAccessRevoked = data?.isAccessRevoked || false;
    this.contactSupport = data?.contactSupport || false;
    this.emiCreation = data?.emiCreation || null;
    this.paymentType = data?.paymentType || "";
    this.isEZPayEnabled = data?.isEZPayEnabled || "";
    this.centerTypeIds = data?.centerTypeIds || [];
    this.verticalId = data?.verticalId || "";
    if (data.hasOwnProperty("enableDpp")) this.enableDpp = data.enableDpp;
    else this.enableDpp = true;
    if (data.hasOwnProperty("enableDppPdfs"))
      this.enableDppPdfs = data.enableDppPdfs;
    else this.enableDppPdfs = true;
    if (data.hasOwnProperty("enableDppVideos"))
      this.enableDppVideos = data.enableDppVideos;
    else this.enableDppVideos = true;
    if (data.hasOwnProperty("enableNotes")) this.enableNotes = data.enableNotes;
    else this.enableNotes = true;
  }
}

export enum EmiCreationEnum {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export class Fee {
  amount: number;
  tax: number;
  discount: number;
  total: number;
  adjustmentDiscount: number;

  constructor(data: any = {}) {
    this.amount = data?.amount || 0;
    this.tax = data?.tax || 0;
    this.discount = data?.discount || 0;
    this.total = data?.total || 0;
    this.adjustmentDiscount = data?.adjustmentDiscount || 0;
  }
}

export interface FileId {
  _id: string;
  baseUrl: string;
  key: string;
  name: string;
}

export interface Schedule {
  _id: string;
  day: string;
  startTime: Date;
  endTime: Date;
}

export class ImageId {
  baseUrl: string;
  name: string;
  key: string;
  _id: string;
  url: string;
  constructor(data: any) {
    data = data || {};
    this.baseUrl = data.baseUrl || "";
    this.name = data.name || "";
    this.key = data.key || "";
    this._id = data._id || "";
    this.url = this.baseUrl + this.key;
  }
}

export interface TeacherId {
  _id: string;
  firstName: string;
  lastName: string;
  imageId: ImageId;
  qualification: string;
  url: string;
}

export interface Subject {
  _id: string;
  fileId: FileId;
  imageId: ImageId;
  subject: string;
  schedules: Schedule[];
  teacherIds: TeacherId[];
  slug: string;
  subjectId: string;
  tagCount: number;
  lectureCount: number;
}

export interface BatchPdf {
  _id: string;
  baseUrl: string;
  name: string;
  key: string;
}

export interface Meta {
  _id: string;
  key: string;
  value: string;
  displayOrder: number;
}

export interface StudyMaterial {
  _id: string;
  type: string;
  typeId: string;
}

export class Program {
  _id: string;
  name: string;
  board: string;
  class: string;
  exam: string[];
  language: string;

  constructor(data: any = {}) {
    this._id = data?._id || "";
    this.name = data?.name || "";
    this.board = data?.board || "";
    this.class = data?.class || "";
    this.exam = data?.exam || [];
    this.language = data?.language || "";
  }
}

export interface Teacher {
  name: string;
  _id: string;
}

export enum BATCH_TYPE {
  E_BATCH = "E_BATCH",
  MAHAPACK = "MAHAPACK",
}

export class TeacherModel {
  firstName: string;
  lastName: string;
  imageId: FileModal;
  experience: string;
  sub: string;
  _id: string;
  featuredLine: string;
  tags: string[];
  tagLines: string[];
  about: string;
  qualification: string;
  subject: string;

  constructor(props: any) {
    props = props || {};
    this._id = props._id || "";
    this.experience = props.experience || "";
    this.firstName = props.firstName || "";
    this.lastName = props.lastName || "";
    this.sub = props.subName || "";
    if (props && props.imageId) {
      this.imageId = new FileModal(props.imageId) || new FileModal({});
    } else {
      this.imageId = new FileModal({});
    }
    this.about = props.about || "";
    this.qualification = props.qualification || "";
    if (props && props.tags && props.tags.length > 0) {
      this.tags = props.tags;
    }else{
        this.tags = [];
    }
    this.featuredLine = props.featuredLine || "";
    this.subject = props.subject || "";
    if (props && props.tagLines && props.tagLines.length > 0) {
      this.tagLines = props.tagLines;
    } else {
      this.tagLines = [];
    }
  }
}

export interface RecentlyWatchedVideoStatsObject {
  success: boolean;
  data: videoStatsData[];
}

export interface videoStatsData {
  userId: string;
  videoId: string;
  timeWatchedInSecTimestamp: number;
  type: string;
  typeId: string;
  isComplete: boolean;
  batchId: string;
  batchSubjectId: string;
  programId: string;
  lastWatchedPointInSec: number;
}

export class PurchasedPremiumBatchesModel {
  _id: string;
  type: string;
  status: string;
  language: string;
  exam: string;
  name: string;
  batchCode: string;
  organizationId: string;
  startDate: string;
  endDate: string;
  slug: string;
  masterBatchId: string;
  webinarId: string;
  class: string;
  examYear: string;
  previewImage: PreviewImage;
  cohortId: string;
  isExpiringSoon: boolean;
  expiryDays: number;

  constructor(data: any = {}) {
    this._id = data._id || "";
    this.type = data.type || "";
    this.status = data.status || "";
    this.exam = data.exam || "";
    this.language = data.language || "";
    this.name = data.name || "";
    this.batchCode = data.batchCode || "";
    this.organizationId = data.organizationId || "";
    this.startDate = data.startDate || "";
    this.endDate = data.endDate || "";
    this.slug = data.slug || "";
    this.masterBatchId = data.masterBatchId || "";
    this.webinarId = data.webinarId || "";
    this.class = data.class || "";
    this.examYear = data.examYear || "";
    this.previewImage = new PreviewImage(data?.previewImage || {});
    this.expiryDays = data?.expiryDays || 0;
    this.isExpiringSoon = data?.isExpiringSoon || false;
    this.cohortId = data?.cohortId || "";
  }
}

export class PreviewImage {
  _id: string;
  name: string;
  baseUrl: string;
  key: string;

  constructor(data: any = {}) {
    this._id = data._id || "";
    this.name = data.name || "";
    this.baseUrl = data.baseUrl || "";
    this.key = data.key || "";
  }
}

export interface BookmarkTogglePayload {
  module: string;
  moduleId: string;
  type: string;
  typeId: string;
  meta: {
    exam: string;
  };
}
